// Shipping types
import noneCoverageIcon from '../assets/platform/icons/shipping_types/none.svg'
import celuDeliveryIcon from '../assets/platform/icons/shipping_types/celudelivery.svg'
import localDeliveryIcon from '../assets/platform/icons/shipping_types/local.svg'
import nationalDeliveryIcon from '../assets/platform/icons/shipping_types/national.svg'
import expressDeliveryIcon from '../assets/platform/icons/shipping_types/express.svg'
// Payment types
import paypal from '../assets/platform/icons/payment_methods/paypal.png'
import mercadopago from '../assets/platform/icons/payment_methods/mercado_pago.png'
import card from '../assets/platform/icons/payment_methods/credit_card.png'
import cash_icon from '../assets/platform/icons/payment_methods/money.png'
import tpv_icon from '../assets/platform/icons/payment_methods/credit_card.png'

// Payment cards
import amex_logo from '../assets/platform/icons/credit_cards/amex_color.png'
import cb_logo from '../assets/platform/icons/cards/carte-bancaire.png'
import diners_logo from '../assets/platform/icons/cards/diners-club.png'
import discover_logo from '../assets/platform/icons/cards/discover.png'
import jcb_logo from '../assets/platform/icons/cards/jcb.png'
import mastercard_logo from '../assets/platform/icons/credit_cards/mastercard_color.png'
import visa_logo from '../assets/platform/icons/credit_cards/visa_color.png' 
import unionpay_logo from '../assets/platform/icons/cards/unionpay.png' 

// Order statuses icons
import receivedIcon from '../assets/platform/icons/order_statuses/received.svg'
import preparingIcon from '../assets/platform/icons/order_statuses/preparing.svg'
import inTransitIcon from '../assets/platform/icons/order_statuses/in_transit.svg'
import arrivedIcon from '../assets/platform/icons/order_statuses/arrived.svg'
import deliveredIcon from '../assets/platform/icons/order_statuses/delivered.svg'
import issueIcon from '../assets/platform/icons/order_statuses/issue.svg'

import errorOrderIcon from '../assets/platform/icons/order_statuses/error.svg'
import packageIcon from '../assets/platform/icons/order_statuses/package.svg'
import pendingOrderIcon from '../assets/platform/icons/order_statuses/pending.svg'

export const catalogs = {
    genders:[
        {value:1, label:'Hombre'},
        {value:2, label:'Mujer'},
        {value:3, label:'Otro'},
        {value:4, label:'Desconocido'},
    ],
    user_statuses:[
        {value:3, label:'Activo'},
        {value:4, label:'Inhabilitado'},
    ],
    mobile_country_codes:[
        {value:1, label:'+52', country:'México', icon:null},
        {value:2, label:'+57', country:'Colombia', icon:null},
        {value:3, label:'+1', country:'Estados Unidos', icon:null},
    ],
    shipping_types:[
        {value:1, label:'Sin cobertura', icon:"/assets/images/icons/shipping_types/nove.svg", description:'Lo lamentamos, pronto estaremos contigo'},
        {value:2, label:'Express', icon:"/assets/images/icons/shipping_types/express.svg", description:'Estaremos pronto contigo'},
        {value:3, label:'Local plus', icon:"/assets/images/icons/shipping_types/local.svg", description:'Menos de 24 horas'},
        {value:4, label:'Nacional plus', icon:"/assets/images/icons/shipping_types/national.avg", description:'De 3 a 5 días hábiles'},
        {value:5, label:'Celuenvío plus', icon:"/assets/images/icons/shipping_types/celudelivery.svg", description:'Estaremos pronto contigo'},
        {value:6, label:'Celuenvío', icon:"/assets/images/icons/shipping_types/celudelivery.svg", description:'Estaremos pronto contigo'},
        {value:7, label:'Local', icon:"/assets/images/icons/shipping_types/local.svg", description:'Menos de 24 horas'},
        {value:8, label:'Nacional', icon:"/assets/images/icons/shipping_types/national.avg", description:'De 3 a 5 días hábiles'},
    ],
    payments_types:[
        {value:1, label:'Tarjeta de crédito/débito', img:card},
        {value:2, label:'Paypal', img:paypal},
        {value:3, label:'Mercado Pago', img:mercadopago},
        {value:4, label:'Efectivo', img:cash_icon},
        {value:5, label:'TPV', img:tpv_icon},
    ],
    payment_statuses:[
        {value:1, label:'Pendiente', color:'#AF78AD'},
        {value:2, label:'Declinado', color:'#D95D71'},
        {value:3, label:'Expirado', color:'#D95D71'},
        {value:4, label:'Pagado', color:'#96AE76'},
        {value:5, label:'Reembolsado', color:'#6971B3'},
        {value:6, label:'Parcialmente reembolsado', color:'#6971B3'},
        {value:7, label:'Cargo regresado', color:'#D95D71'},
        {value:8, label:'Preautorizado', color:'#D95D71'},
        {value:9, label:'Cancelado', color:'#D95D71'},
    ],
    order_statuses:[
        {value:1, svg:receivedIcon, color:'#CBB792', label:'Pendiente de pago', description:'Hemos recibido tu pedido', colorS:'#ffa000', icon:'report_problem'},
        {value:2, svg:pendingOrderIcon, color:'#AF78AD', label:'Pendiente', description:'Hemos recibido tu pedido', colorS:'#303f9f', icon:'local_shipping'},
        {value:3, svg:inTransitIcon, color:'#543081', label:'Enviado', description:'Tu pedido está en ruta', colorS:'#0097a7', icon:'local_shipping'},
        {value:4, svg:deliveredIcon, color:'#96AE76', label:'Entregado', description:'Tu pedido ha sido entregado', colorS:'#388e3c', icon:'check'},
        {value:5, svg:errorOrderIcon, color:'#D95D71', label:'Cancelado', description:'Tu pedido fue cancelado', colorS:'#d32f2f', icon:'error_outline'},
        {value:6, svg:issueIcon, color:'#D95D71', label:'Problema', description:'Ocurrió un problema con tu pedido, por favor contáctanos', colorS:'#f57c00', icon:'local_shipping'},
        {value:7, svg:issueIcon, color:'#D95D71', label:'Devuelto', description:'Ocurrió un problema con tu pedido, por favor contáctanos', colorS:'#cddc39', icon:'local_shipping'},
        {value:8, svg:issueIcon, color:'#D95D71', label:'Reembolsado', description:'Ocurrió un problema con tu pedido, por favor contáctanos', colorS:'#7b1fa2', icon:'local_shipping'},
        {value:9, svg:issueIcon, color:'#D95D71', label:'Problema de envío', description:'Hubo un problema con tu envío, lo estaremos reenviando de inmediato', colorS:'#006064', icon:'error_outline'},
        {value:10, svg:issueIcon, color:'#D95D71', label:'Problema con el pago', description:'Ocurrió un problema con el pago', colorS:'#ff6f00', icon:'error_outline'},
        {value:11, svg:packageIcon, color:'#6971B3', label:'Entrega pendiente', description:'El pedido pronto estará listo para ser recogido', colorS:'#ff6f00', icon:'local_shipping'},
    ],
    route_order_statuses:[
        {value:0, label:'Recibido', description:'¡Hemos recibido tu orden!', color:'rgb(203, 183, 146)', svg:receivedIcon},
        {value:1, label:'Preparando', description:'¡Estamos preparando tu pedido!', color:'rgb(175, 120, 173)', svg:preparingIcon},
        {value:2, label:'En camino', description:'¡Tu paquete ya está en camino', color:'rgb(84, 48, 129)', svg:inTransitIcon},
        {value:3, label:'¡Llegamos!', description:'¡Estamos en tu domicilio!', color:'rgb(105, 113, 179)', svg:arrivedIcon},
        {value:4, label:'Entregado', description:'', color:'rgb(150, 174, 118)', svg:deliveredIcon},
        {value:5, label:'Problema', description:'', color:'rgb(217, 93, 113)', svg:issueIcon    },
    ],
    route_statuses:[
        {value:1, label:'Pendiente', color:'rgb(203, 183, 146)', svg:receivedIcon},
        {value:2, label:'Asignado', color:'rgb(0, 121, 107)', svg:preparingIcon},
        {value:3, label:'Preparando', color:'rgb(25, 118, 210)', svg:inTransitIcon},
        {value:4, label:'Listo', color:'rgb(175, 120, 173)', svg:arrivedIcon},
        {value:5, label:'En tránsito', color:'rgb(84, 48, 129)', svg:deliveredIcon},
        {value:6, label:'Completado', color:'rgb(150, 174, 118)', svg:issueIcon    },
        {value:7, label:'Cancelado', color:'rgb(244, 67, 54)', svg:issueIcon    },
    ],
    route_cancellation_motives:[
        {value:1, label:'Accidente', color:'rgb(203, 183, 146)', svg:receivedIcon},
        {value:2, label:'Avería del Vehículo', color:'rgb(0, 121, 107)', svg:preparingIcon},
        {value:3, label:'Robo', color:'rgb(25, 118, 210)', svg:inTransitIcon},
        {value:4, label:'Problemas Técnicos', color:'rgb(175, 120, 173)', svg:arrivedIcon},
    ],
    currencies:[
        {value:2, label:'MXN'},
        {value:1, label:'USD'},
    ],
    discount_types:[
        {value:1, label:'Descuento ($)'},
        {value:2, label:'Paquete QxQ'},
        {value:3, label:'Paquete'},
    ],
    product_statuses:[
        {value:1, label:'Regular', color:'success'},
        {value:2, label:'Descontinuado', color:'warning'},
        {value:3, label:'Obsoleto', color:'warning'},
        {value:4, label:'Sin stock', color:'error'},
    ],
    order_levels:[
        {value:1, label:'1'}, {value:2, label:'2'}, {value:3, label:'3'}, {value:4, label:'4'}, {value:5, label:'5'},
        {value:6, label:'6'}, {value:7, label:'7'}, {value:8, label:'8'}, {value:9, label:'9'}, {value:10, label:'10'},
        {value:11, label:'11'}, {value:12, label:'12'}, {value:13, label:'13'}, {value:14, label:'14'}, {value:15, label:'15'},
        {value:16, label:'16'}, {value:17, label:'17'}, {value:18, label:'18'}, {value:19, label:'19'}, {value:20, label:'20'}
    ],
    pharmacy_payment_statuses:[
        {value:1, label:'Pendiente de Factura', color:'#AF78AD'},
        {value:2, label:'Pendiente de Pago', color:'#543081'},
        {value:3, label:'Pagado', color:'#96AE76'},
        {value:4, label:'Cancelado', color:'#D95D71'},
    ],

}

export const CARDS = {
    'amex':{
        pattern:'**** **** **** ',
        logo:amex_logo,
    },
    'diners_club':{
        pattern:'**** **** **** ',
        logo:diners_logo,
    },
    'discover':{
        pattern:'**** **** **** ',
        logo:discover_logo,
    },
    'jcb':{
        pattern:'**** **** **** ',
        logo:jcb_logo,
    },
    'mastercard':{
        pattern:'**** **** **** ',
        logo:mastercard_logo,
    },
    'unionpay':{
        pattern:'**** **** **** ',
        logo:unionpay_logo,
    },
    'visa':{
        pattern:'**** **** **** ',
        logo:visa_logo,
    },
    'cartes_bancaires':{
        pattern:'**** **** **** ',
        logo:cb_logo,
    },
}
